module.exports = __webpack_public_path__ + "img/2.92a0cb64.jpg";